import { css } from '@emotion/react';
import Skeleton from '@mui/material/Skeleton';

import { Box } from '../shared/Box';

export const DashboardPlaceholder = () => (
  <Box
    css={css`
      & .MuiSkeleton-root {
        border-radius: 4px;
      }
    `}
  >
    <Box pb={1} width="45%">
      <Skeleton variant="rectangular" height="24px" />
    </Box>
    <Box pb={1}>
      <Skeleton variant="rectangular" height="16px" />
    </Box>
    <Box pb={2} width="33%">
      <Skeleton variant="rectangular" height="16px" />
    </Box>
  </Box>
);
